<template>
  <div class="room pt-3 room_clothes">
  	<div v-if="typeof room_data_tmp !== 'undefined'">
	  	<b-container class="mt-3">
	  		<b-row>
	  			<b-col cols="12" class="text-center">
	  				<h4 class="m-0 color-green font-weight-bold">{{room_data_tmp.room.room_number}}</h4>
	  			</b-col>
	  		</b-row>
	  		<b-row class="mt-3">
	  			<b-col cols="12">
	  				<table class="table text-center table-striped">
	  					<thead class="bg-grey-dark text-white">
						    <tr>
						    	<th class="text-left" scope="col">{{trans['ROUPA']}}</th>
						    	<!-- <th class="text-center" scope="col">Quantidade</th> -->
						    	<th class="text-center" scope="col">{{trans['SUJA']}}</th>
						    	<th class="text-center" scope="col">{{trans['EM_FALTA']}}</th>
						    </tr>
						</thead>
	  					<tbody>
	  						<tr v-for="(item, idx) in sorted_clothes" :key="idx" class="text-left">
	  							<td scope="row" class="text-left align-middle">
                                    <span class="align-middle d-inline-block">
                                    {{item.complete_name}}</span>&nbsp;
                                    <span v-if="item.color !== null" class="d-inline-block rounded-circle align-middle color-stamp" :style="'background-color:' +item.color"></span>
                                    <span v-if="item.color !== null">&nbsp;</span>
                                    <span v-if="item.code !== null" class="d-inline-block rounded-pill bg-green-light py-1 px-2 text-white">
                                        {{item.code}}
                                    </span>
                                </td>
	  							<!-- <td scope="row" class="text-center">{{item.pivot.quantity}}</td> -->

	  							<!-- DESKTOP DISPLAY -->
	  							<td scope="row" class="text-center d-none d-sm-table-cell">
									<b-button v-on:click="update_replaced_quantity(item, -1)" class="no-border bg-green-light"><b class="fa fa-minus"></b></b-button>
									<b class="pl-3 pr-3">{{item.replace_quantity}}</b>
									<b-button v-on:click="update_replaced_quantity(item, 1)" class="no-border bg-green-light"><b class="fa fa-plus"></b></b-button>
								</td>
	  							<td scope="row" class="text-center d-none d-sm-table-cell">
	  								<b-button v-on:click="update_missing_quantity(item, -1)" class="no-border bg-green-light"><b class="fa fa-minus"></b></b-button>
									<b class="pl-3 pr-3">{{item.missing_quantity}}</b>
									<b-button v-on:click="update_missing_quantity(item, 1)" class="no-border bg-green-light"><b class="fa fa-plus"></b></b-button>
	  							</td>
	  							
	  							<!-- MOBILE DISPLAY -->
	  							<td scope="row" class="text-center d-table-cell d-sm-none">
									<b-button v-on:click="update_replaced_quantity(item, 1)" class="no-border bg-green-light"><b class="fa fa-plus"></b></b-button>
									<br>
									<b class="pl-3 pr-3">{{item.replace_quantity}}</b>
									<br>
									<b-button v-on:click="update_replaced_quantity(item, -1)" class="no-border bg-green-light"><b class="fa fa-minus"></b></b-button>
								</td>
	  							<td scope="row" class="text-center d-table-cell d-sm-none">
									<b-button v-on:click="update_missing_quantity(item, 1)" class="no-border bg-green-light"><b class="fa fa-plus"></b></b-button>
	  								<br>
									<b class="pl-3 pr-3">{{item.missing_quantity}}</b>
									<br>
	  								<b-button v-on:click="update_missing_quantity(item, -1)" class="no-border bg-green-light"><b class="fa fa-minus"></b></b-button>
	  							</td>
	  						</tr>
	  					</tbody>
  						<tfoot>
	  						<tr>
								<th scope="row" class="text-left">{{trans['TOTAL']}}</th>
								<!-- <th scope="row" class="text-center">{{total_dist_room_clothes}}</th> -->
								<th scope="row" class="text-center">{{total_clothes_replaced}}</th>
								<th scope="row" class="text-center">{{total_clothes_missing}}</th>
							</tr>
						</tfoot>
	  				</table>
	  			</b-col>
	  		</b-row>
	  		<b-row>
	  			<b-col cols="12" class="mt-3 mb-4">
					<div>
						<div>
							<label for="inp-observation">{{trans['OBSERVACOES']}}</label>
							<b-form-textarea
						      id="inp-observation"
                              v-model.lazy="room_data_tmp.observation"
						      placeholder=""
						      rows="3"
						      max-rows="6"
						    ></b-form-textarea>
						</div>
					</div>
	  			</b-col>
	  		</b-row>
	  	</b-container>
	</div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'room_clothes',
  props: ['room'],
  data() {
  	return {
  		loading: false,
	  	can_save: true,
        room_data_tmp: null,
  	}
  },
  methods: {
  	update_replaced_quantity: function(item, val) {
  		if(!this.can_save) return;
  		if(item.replace_quantity <= 0 && val < 0) {
  			return;
  		}
  		item.replace_quantity = parseInt(item.replace_quantity) + val;
  	},
  	update_missing_quantity: function(item, val) {
  		if(!this.can_save) return;
  		if(item.missing_quantity <= 0 && val < 0) {
  			return;
  		}
  		item.missing_quantity = parseInt(item.missing_quantity) + val;
  	},
    save: function(save) {
        if(save) {
            this.$emit('set_loading', true);
            this.room_data.room        = JSON.parse(JSON.stringify(this.room_data_tmp.room));
            this.room_data.observation = this.room_data_tmp.observation;
            this.room_data.saved       = 0;
            this.$emit('go_to', {
                name  : 'list_rooms',
                params: {
                    cod_dist_zone: this.room_data.cod_distribution_zone,
                    elem_scroll  : "room_" + this.room_data.room.room_number,
					search_hotel: this.$distribution.search_hotel,
					search_bloco: this.$distribution.search_bloco,
					search_piso: this.$distribution.search_piso,
					search_n_quarto: this.$distribution.search_n_quarto
                }
            });
        } else {
            this.room_data_tmp = JSON.parse(JSON.stringify(this.room_data));
        }
    },
  	send_data: function(items) {
  		if(items.length > 0 && this.can_save) {
  			this.can_save = false;
			this.$http.post('housekeeping/update_rooms?token=' +this.$distribution.person.token,
				{
					rooms: items
				},
				{
					before(request) {
				}
			})
			.then(resp => {
				for(var r of resp.body.rooms) {
		            for(var z of this.$distribution.zones) {
		              var r_idx = z.rooms.findIndex((item, idx) => item.cod_distribution_room == r.cod_distribution_room);
		              if(r_idx !== -1) {
		              	this.$set(z.rooms, r_idx, r);
		              }
		            }
		        }
			}, resp => {

			}).then(resp => {
				this.can_save = true;
			});
		}
  	}
  },
  computed: {
    room_data: function() {
        if(typeof this.room !== 'undefined') { // check if we can use prop sent by router link
            return this.room;
        }
        let zone = this.get_zone();
        if(typeof zone !== 'undefined') {
            let room = this.get_room(zone);
            if(typeof room !== 'undefined') {
                return room;
            }
        }
  	},
  	sorted_clothes: function() {
  		return this.room_data_tmp.room.clothes_details.sort((a, b) => a.complete_name.toLowerCase().localeCompare(b.complete_name.toLowerCase()));
  	},
  	total_dist_room_clothes: function() {
  		return this.room_data_tmp.room.clothes_details.reduce((current_sum, item) => current_sum + parseInt(item.pivot.quantity), 0);
  	},
  	total_clothes_replaced: function() {
  		return this.room_data_tmp.room.clothes_details.reduce((current_sum, item) => current_sum + parseInt(item.replace_quantity), 0);
  	},
  	total_clothes_missing: function() {
  		return this.room_data_tmp.room.clothes_details.reduce((current_sum, item) => current_sum + parseInt(item.missing_quantity), 0);
  	},
  },
  watch: {

  },
  created: function() {
  	if(typeof this.room_data === 'undefined') {
		this.$router.push({name: 'login', params: {lang: this.$route.params.lang}});
		return;
	}

    this.room_data_tmp = JSON.parse(JSON.stringify(this.room_data));
  }
}
</script>
<style scoped>
	
</style>